import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Paper,
} from "@mui/material";

const Transportation = () => {
  const transportOptions = [
    { id: 1, name: "Morning Shuttle", timing: "7:00 AM - 8:00 AM", color: "#FFB74D" },
    { id: 2, name: "Evening Shuttle", timing: "5:00 PM - 6:00 PM", color: "#64B5F6" },
    { id: 3, name: "Weekend Outing Bus", timing: "10:00 AM - 4:00 PM", color: "#81C784" },
    { id: 4, name: "Airport Pickup", timing: "On Request", color: "#FF8A65" },
  ];

  return (
    <Box sx={{ 
      padding: 2, 
      // bgcolor: "#f5f5f5", 
      maxHeight: "100vh", // Set max height
      overflowY: "auto", // Enable vertical scrolling
    }}>
      <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 'bold', color: '#333' }}>
        Transportation Services 
      </Typography>
      <Typography variant="h6" align="center" sx={{ marginBottom: 2, color: '#555' }}>
        Convenient transport options for your daily needs!
      </Typography>

      <Grid container spacing={2} justifyContent="center">
        {transportOptions.map((option) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={option.id}>
            <Card 
              sx={{ 
                boxShadow: 3, 
                backgroundColor: option.color, 
                transition: 'transform 0.3s', 
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: 6,
                }
              }}
            >
              <CardContent>
                <Typography variant="h5" gutterBottom sx={{ color: '#fff' }}>
                  {option.name}
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ color: '#fff' }}>
                  Timings: {option.timing}
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ marginTop: 2 }}
                >
                  Book Now
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ marginTop: 4, padding: 2, bgcolor: '#fff', boxShadow: 2 }}>
        <Typography variant="h6" gutterBottom>
          How to Book:
        </Typography>
        <Typography variant="body1">
          1. Choose your desired transport service from the list.
        </Typography>
        <Typography variant="body1">
          2. Click on "Book Now" for the selected service.
        </Typography>
        <Typography variant="body1">
          3. You will receive a confirmation for your booking.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Transportation;